import { apiClient } from '@/api/client';
import type {
  GetTutorWishlistCaseOptionsResponse,
  GetTutorWishlistsParams,
  GetTutorWishlistsResponse,
  ReplaceTutorWishlistCasesRequest,
  ReplaceTutorWishlistCasesResponse,
  TutorWishlistData,
} from '@/types/api';

export const getTutorWishlistCaseOptions = async (
  tutorId: string,
  signal?: AbortSignal
): Promise<GetTutorWishlistCaseOptionsResponse['data']> => {
  const response = await apiClient.get<GetTutorWishlistCaseOptionsResponse>(
    `/wishlists/tutors/${tutorId}/case-options`,
    { signal }
  );

  return response.data.data;
};

export const replaceTutorWishlistCases = async (
  tutorId: string,
  request: ReplaceTutorWishlistCasesRequest,
  debugRequestId?: string
): Promise<ReplaceTutorWishlistCasesResponse['data']> => {
  const response = await apiClient.put<ReplaceTutorWishlistCasesResponse>(
    `/wishlists/tutors/${tutorId}/cases`,
    request,
    debugRequestId ? { headers: { 'x-debug-request-id': debugRequestId } } : undefined
  );

  return response.data.data;
};

export const getTutorWishlists = async (
  params?: GetTutorWishlistsParams,
  signal?: AbortSignal
): Promise<{
  data: TutorWishlistData[];
  pagination: { total: number; page: number; limit: number; totalPages: number };
}> => {
  const response = await apiClient.get<GetTutorWishlistsResponse>('/wishlists/tutors', {
    params,
    signal,
  });

  return {
    data: response.data.data.data,
    pagination: response.data.data.pagination,
  };
};

export const wishlistsApi = {
  getTutorWishlistCaseOptions,
  replaceTutorWishlistCases,
  getTutorWishlists,
};
